import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Input, Row, Space, Table, Tag, TimeRangePickerProps } from "antd";
import Column from 'antd/es/table/Column';
import dayjs, { Dayjs } from 'dayjs';
import { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { ContentHeader } from "../../components";
import { searchLength, trangThaiCongViec, trangThaiDonNghiPhep } from '../../constants';
import { Links } from "../../helpers/Links";
import { menuHelper } from "../../helpers/account";
import { dateCommon } from '../../helpers/common';
import { CongViecPagingResponse } from '../../models/congviec/CongViec';
import { timKiemCongViec } from '../../services/congviec';

const DanhSachCongViec = () => {
    const menu: any = menuHelper.checkMultiPermission([
        Links.CongViec.Xem,
        Links.CongViec.Them,
        Links.CongViec.GiaoViec
    ]);
    const [isLoadingTable, setIsLoadingTable] = useState<boolean>(false);
    const [reloadPage, setReloadPage] = useState<boolean>(true);
    const [tuKhoa, setTuKhoa] = useState<string>("");
    const { RangePicker } = DatePicker;
    const dateFormat = ["DD/MM/YYYY", "DDMMYYYY"];
    const now = dayjs();
    const startOfMonth = now.startOf('month');
    const endOfMonth = now.endOf('month');
    const [tuNgay, setTuNgay] = useState<string>(startOfMonth.format(dateFormat[0]));
    const [denNgay, setDenNgay] = useState<string>(endOfMonth.format(dateFormat[0]));
    const [danhSach, setDanhSach] = useState<CongViecPagingResponse>({
        "data": [],
        "recordsTotal": 0,
        "maxPage": 0,
        "pageCurrent": 0,
        "pageListShow": [0]
    });

    const timkiem = async (tuKhoa: string, tuNgay: string, denNgay: string, start: number, length: number, page: number) => {
        try {
            setIsLoadingTable(true);
            const temp = await timKiemCongViec(tuKhoa, tuNgay, denNgay, start, length);
            const maxPage = temp?.recordsTotal === 0 ? 0 : (parseInt((temp?.recordsTotal / searchLength).toString()) + (temp?.recordsTotal % searchLength ? 0 : -1)) || 0;
            setDanhSach({
                "data": (temp?.data || []).map((item: any) => {
                    return { ...item, key: item.id }
                }),
                "recordsTotal": temp?.recordsTotal || 0,
                "maxPage": maxPage,
                "pageCurrent": page,
                "pageListShow": []
            });
            setIsLoadingTable(false);
        }
        catch (error: any) {
            toast.error(error.message);
            setIsLoadingTable(false);
        };
    }

    const rangePresets: TimeRangePickerProps['presets'] = [
        { label: "Hôm hiện tại", value: [dayjs().startOf('day'), dayjs().endOf('day')], },
        { label: "Hôm qua", value: [dayjs().add(-1, 'day').startOf('day'), dayjs().add(-1, 'd').endOf('day')], },
        { label: "Ngày mai", value: [dayjs().add(1, 'day').startOf('day'), dayjs().add(1, 'd').endOf('day')], },
        { label: 'Tuần hiện tại', value: [dayjs().startOf('week'), dayjs().endOf('week')] },
        { label: 'Tuần trước', value: [dayjs().add(-1, 'week').startOf('week'), dayjs().add(-1, 'week').endOf('week')] },
        { label: 'Tuần sau', value: [dayjs().add(1, 'week').startOf('week'), dayjs().add(1, 'week').endOf('week')] },
        { label: 'Tháng hiện tại', value: [dayjs().startOf('month'), dayjs().endOf('month')] },
        { label: 'Tháng trước', value: [dayjs().add(-1, 'month').startOf('month'), dayjs().add(-1, 'month').endOf('month')] },
        { label: 'Tháng sau', value: [dayjs().add(1, 'month').startOf('month'), dayjs().add(1, 'month').endOf('month')] },
    ];

    const onRangeChange = (dates: null | (Dayjs | null)[], dateStrings: string[]) => {
        if (dates) {
            var tuNgayStr = dates[0]?.format(dateFormat[0]);
            var denNgayStr = dates[1]?.format(dateFormat[0]);
            setTuNgay(tuNgayStr || "");
            setDenNgay(denNgayStr || "");
            timkiem(tuKhoa, tuNgayStr || "", denNgayStr || "", 0, 0, 0);
        } else {
            setTuNgay("");
            setDenNgay("");
            timkiem(tuKhoa, "", "", 0, 0, 0);
        }
    };

    useEffect(() => {
        if (reloadPage) {
            setDanhSach({
                "data": [],
                "recordsTotal": 0,
                "maxPage": 0,
                "pageCurrent": 0,
                "pageListShow": [0]
            });
            timkiem(tuKhoa, tuNgay, denNgay, 0, 0, 0);
            setReloadPage(false);
        }
    }, [reloadPage]);

    return (
        <section>
            <ContentHeader title="Danh sách công việc" />
            <Row gutter={8} className="form-group">
                <Col span={6}>
                    <RangePicker
                        changeOnBlur={true}
                        style={{ width: "100%" }}
                        placeholder={["Từ ngày", "Đến ngày"]}
                        format={dateFormat}
                        defaultValue={[
                            dayjs(startOfMonth, dateFormat),
                            dayjs(endOfMonth, dateFormat)
                        ]}
                        presets={rangePresets}
                        onChange={onRangeChange}
                    />
                </Col>
                <Col span={8}>
                    <Input prefix={<SearchOutlined rev="" />} placeholder="Nhập nội dung công việc" onChange={(e) => setTuKhoa(e.target.value)} />
                </Col>
                <Col span={4}>
                    <Button type="primary" icon={<SearchOutlined rev="" />} onClick={() => timkiem(tuKhoa, tuNgay, denNgay, 0, 0, 0)}>
                        Tìm kiếm
                    </Button>
                </Col>
                <Col span={6}>
                    <Space className='float-right'>
                        {
                            menu[Links.CongViec.Them] &&
                            <Link
                                className="hrm-btn hrm-btn-warning float-right"
                                to={Links.CongViec.Them}
                            >
                                <PlusOutlined rev="" />Thêm mới
                            </Link>
                        }
                        {
                            menu[Links.CongViec.GiaoViec] &&
                            <Link
                                className="hrm-btn hrm-btn-warning float-right"
                                to={Links.CongViec.GiaoViec}
                            >
                                <PlusOutlined rev="" />Giao việc
                            </Link>
                        }
                    </Space>
                </Col>
            </Row>
            <Row>
                <Col span="24">
                    <div className="card card-primary">
                        <Table
                            dataSource={danhSach.data}
                            loading={isLoadingTable}
                            locale={{ emptyText: "Không có dữ liệu" }}
                            rowKey=""
                        >
                            <Column
                                title="STT"
                                dataIndex="id"
                                key="id"
                                width="60px"
                                render={(value, record: any, index) => {
                                    return index + 1;
                                }}
                            />
                            <Column title="Nội dung" dataIndex="noiDung" key="noiDung" render={(value, record) => {
                                return value.length > 200 ? value.substring(0, 200) + "..." : value;
                            }}
                            />
                            <Column title="Giao việc" width="10%" dataIndex="tenNhanVien" key="tenNhanVien" />
                            <Column title="Thực hiện" width="20%" dataIndex="nhanViens" key="nhanViens"
                                render={(value, record) => {
                                    return (value || []).map((x: { tenNhanVien: any; }) => x.tenNhanVien).join(', ');
                                }}
                            />
                            <Column title="TG giao" width="7%" dataIndex="thoiGianGiao" key="thoiGianGiao"
                                render={(value, record) => {
                                    return dateCommon.formatDate(value);
                                }}
                            />
                            <Column title="TG yêu cầu" width="7%" dataIndex="thoiGianYeuCauHoanThanh" key="thoiGianYeuCauHoanThanh"
                                render={(value, record) => {
                                    return dateCommon.formatDate(value);
                                }}
                            />
                            <Column title="TG hoàn thành" width="8%" dataIndex="ngayHoanThanh" key="ngayHoanThanh"
                                render={(value, record) => {
                                    return dateCommon.formatDate(value);
                                }}
                            />
                            <Column title="Trạng thái" width="6%" dataIndex="trangThai" key="trangThai" render={(value, record: any) => {
                                var tag = (<Tag color="default"></Tag>);
                                switch (value) {
                                    case trangThaiCongViec.khoiTao:
                                        if (dayjs(record.thoiGianYeuCauHoanThanh) >= now) {
                                            tag = (<Tag color="processing">Khởi tạo</Tag>);
                                        } else tag = (<Tag color="error">Hết hạn</Tag>);
                                        break;
                                    case trangThaiCongViec.dangThucHien:
                                        if (dayjs(record.thoiGianYeuCauHoanThanh) >= now) {
                                            tag = (<Tag color="warning">Đang thực hiện</Tag>);
                                        } else tag = (<Tag color="error">Hết hạn</Tag>);
                                        break;
                                    case trangThaiCongViec.daHoanThanh:
                                        if (dayjs(record.thoiGianYeuCauHoanThanh) >= dayjs(record.ngayHoanThanh)) {
                                            tag = (<Tag color="success">Đã hành thành</Tag>);
                                        } else tag = (<Tag color="orange">Trễ hạn</Tag>);
                                        break;
                                }
                                return tag;
                            }} />
                            <Column title="" width="5%" dataIndex="action" key="action" render={(value: any, record: any) => {
                                return menu[Links.CongViec.Xem]
                                    ? (<Link className="hrm-btn hrm-btn-sm btn-primary" to={Links.CongViec.Xem + "?id=" + record.id}>Xem</Link>)
                                    : "";
                            }} />
                        </Table>
                    </div>
                </Col>
            </Row>
        </section>
    );
};

export default DanhSachCongViec;